import React from 'react'
import { useSelector } from 'react-redux'
import { CircularProgress, Typography } from '@material-ui/core'

import { EventCard } from '../EventCard'
import { SectionBlock } from '../SectionBlock'

const PastEventsSection = () => {
  const { pastEvents, pastEventsPending } = useSelector((state) => state.organizations)

  return (
    <SectionBlock title={'Eventos anteriores'}>
      {pastEventsPending ? (
        <CircularProgress color='primary' size={32} />
      ) : pastEvents.length > 0 ? (
        pastEvents.map((event) => <EventCard key={event.id} event={event} previous />)
      ) : (
        <Typography variant='body1' color='primary'>
          No hay eventos anterior para el organizador
        </Typography>
      )}
    </SectionBlock>
  )
}

export default PastEventsSection
